import React, { useCallback, useEffect, useState } from 'react'
import { LIMIT_ALL } from '../../../../../constants/pagination'
import Header from '../../../Header'
import * as styled from '../../../style/main.style'
import Navbar from '../../../Navbar'
import { useTranslation } from 'react-i18next'
import { MenuItem, Typography } from '@mui/material'
import FilterSelect from '../../../../../component/select/filterSelect'
import TableCustom from '../../../../../component/table/tableCustom'
import { RouteImage } from '../../../../../assets/routeImage'
import TableRowCommon from '../../../../../component/table/TableRowCommon'
import { motion } from 'framer-motion'
import { ButtonOutlined } from '../../../../../component/mui-custom/MuiCustom'
import { ReportApi } from '../../../../../api/report/report.api';
import { useDispatch, useSelector } from 'react-redux'
import Loading from '../../../../../component/loading/Loading'
import { FiscalYearApi } from '../../../../../api/fiscal-year/fiscalyear.api'
import { StrategyApi } from '../../../../../api/strategy/strategy.api';
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice'
import { saveAs } from 'file-saver'

import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import MenuDropdown from '../../../../../component/menu-dropdown/MenuDropdown'
import { numberFormat } from '../../../../../utils/common'
import StateComponents from '../../../../../component/state-component/StateComponents'
import { TacticsApi } from '../../../../../api/tactics/tactics.api'
import { debouncedApiCall } from '../../../../../utils/app.utils'
import { PlanApi } from '../../../../../api/plan/plan.api'
import { DepartMentApi } from '../../../../../api/department/department.api'
import { ClustersApi } from '../../../../../api/clusters/clusters.api'
import { EmployeesApi } from '../../../../../api/employee/Employees.api'
import { TypesApi } from '../../../../../api/type/type.api'


interface Column {
    id: 'name' | 'code' | 'population' | 'size' | 'density';
    label: string;
    minWidth?: number;
    align?: 'right' | 'center';
    format?: (value: number) => string;
}
const budget: Column[] = [
    { id: 'name', label: 'ได้รับ', align: "right", minWidth: 120 },
    { id: 'name', label: 'เบิกจ่าย', align: "right", minWidth: 120 },
    { id: 'name', label: 'คงเหลือ', align: "right", minWidth: 120 },
];
const performance: Column[] = [
    { id: 'name', align: "right", label: 'ดำเนินการแล้วเสร็จ', minWidth: 170 },
    { id: 'name', align: "right", label: 'อยู่ระหว่างการดำเนินการ', minWidth: 200 },
    { id: 'name', align: "right", label: 'ยังไม่ได้ดำเนินการ', minWidth: 170 },
    { id: 'name', align: "center", label: 'ยกเลิก', minWidth: 160 },
];
const plane: Column[] = [
    { id: 'name', label: 'เป็นตามแผน', minWidth: 130 },
    { id: 'name', label: 'ไม่เป็นตามแผน', minWidth: 130 },
];

const ReportSummary = () => {
    const { t } = useTranslation();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalPage, setTotalPage] = useState<number>(2);

    const [fiscalYear, setFiscalYear] = useState<any[]>([]);

    const [strategy, setStrategy] = useState<any[]>([]);
    const [tactics, set_tactics] = useState<any[]>([]);
    const [plan, setPlan] = useState<any[]>([]);
    const [department, setDepartment] = useState<any[]>([]);
    const [clusters, setClusters] = useState<any[]>([]);
    const [employees, setEmployees] = useState<any[]>([]);
    const [types, setTypes] = useState<any[]>([]);

    const [dataReport, setDataReport] = useState<any[]>([]);

    const [keyword_id_strategy, set_keyword_id_strategy] = useState<string>("");
    const [keyword_id_tactics, set_keyword_id_tactics] = useState<string>("");
    const [keyword_id_plan, set_keyword_id_plan] = useState<string>("");
    const [keyword_id_department, set_keyword_id_department] = useState<string>("");
    const [keyword_id_cluster, set_keyword_id_cluster] = useState<string>("");
    const [keyword_id_employee, set_keyword_id_employee] = useState<string>("");
    const [keyword_id_types, set_keyword_id_types] = useState<string>("");

    const [idFiscalYear, setIdFiscalYear] = useState<number>(0);

    const [filterData, setFilterData] = useState<{ idStrategy: any, idEmployee: any, idType: any, idTactics: any, idPlan: any, idDepartment: any, idClusters: any }>({
        idStrategy: null,
        idTactics: null,
        idPlan: null,
        idDepartment: null,
        idClusters: null,
        idEmployee: null,
        idType: null
    })
    const handleChangeFilterData = (field: string, value: any) => {
        setFilterData((prev) => ({ ...prev, [field]: value }))
    }


    const headCells = [
        {
            id: "FIR",
            disablePadding: true,
            align: "center",
            width: 100,
            label: "ที่"
        },
        {
            id: "idFiscalYear",
            disablePadding: true,
            align: "center",
            width: 200,
            label: "ปีงบประมาณ"
        },
        {
            id: "Stragy",
            disablePadding: true,
            align: "center",
            width: 300,
            label: "ยุทธศาสตร์"
        },
        {
            id: "PLAN",
            disablePadding: true,
            align: "center",
            width: 300,
            label: "แผนงาน"
        },
        {
            id: "tacticsName",
            disablePadding: true,
            width: 180,
            align: "center",
            label: "กลยุทธ์"
        },
        {
            id: "PROJECT-COUNT",
            disablePadding: true,
            width: 180,
            align: "center",
            label: "จำนวนโครงการ"
        },
        {
            id: "BUDGET", width: 380, align: "center", label:
                <TableHead>
                    <TableRow style={{ borderBottom: "2px solid #fff" }}>
                        <TableCell align="center" colSpan={6}>
                            <Typography>{"งบประมาณ"}</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        {budget.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ top: 57, minWidth: column.minWidth, width: "100%" }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
        },
        {
            id: "PERFORMANCE", width: 740, disablePadding: true, align: "center", label:
                <TableHead>
                    <TableRow style={{ borderBottom: "2px solid #fff" }}>
                        <TableCell align="center" colSpan={8}>
                            <Typography>{"ผลการดำเนินงาน"}</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow style={{ textAlign: 'center' }}>
                        {performance.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ top: 57, minWidth: column.minWidth }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
        },
        {
            id: "PLANE", disablePadding: true, width: 300, align: "center", label:
                <TableHead>
                    <TableRow style={{ borderBottom: "2px solid #fff" }}>
                        <TableCell align="center" colSpan={4}>
                            <Typography>{"แผนการดำเนินงาน"}</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow className='text-center'>
                        {plane.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ top: 57, minWidth: column.minWidth }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { id, projectCount, planName,tacticsName, fiscalYear, strategyName, sumAllBudget, sumAllPaid, sumAllUnpaid, completeCount, delayCount, ongoingCount, asPlanCount, notyetCount, cancelCount } =
            objData;

        const objRenderData = {
            key: no,
            id: id,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: fiscalYear,
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: strategyName,
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: planName,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: tacticsName || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: projectCount,
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    width: 400,
                    component:
                        <TableBody sx={{ display: "grid", }} className='grid grid-cols-10 w-full h-full'>
                            <TableCell style={{ textAlign: 'right', border: "none" }} className='text-right col-span-4'>
                                {numberFormat(sumAllBudget) || "0"}
                            </TableCell>
                            <TableCell style={{ textAlign: 'right', border: "none" }} className='text-right col-span-3'>
                                {numberFormat(sumAllPaid) || "0"}
                            </TableCell>
                            <TableCell style={{ textAlign: 'right', border: "none" }} className='text-right col-span-3'>
                                {numberFormat(sumAllUnpaid) || "0"}
                            </TableCell>
                        </TableBody>
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    // colSpan: 8,
                    width: 500,
                    style: { width: "100%" },
                    component:
                        <TableBody>
                            <TableCell style={{ width: "190px", textAlign: "center", border: "none" }} colSpan={2}>
                                {Number(completeCount)}
                            </TableCell>
                            <TableCell style={{ width: "180px", textAlign: "center", border: "none" }} colSpan={2}>
                                {Number(ongoingCount)}
                            </TableCell>
                            <TableCell style={{ width: "190px", textAlign: "center", border: "none" }} colSpan={2}>
                                {Number(notyetCount)}
                            </TableCell>
                            <TableCell style={{ width: "160px", textAlign: "center", border: "none" }} colSpan={2}>
                                {Number(cancelCount)}
                            </TableCell>
                        </TableBody>
                },
                {
                    option: "TEXT",
                    align: "center",
                    width: 300,
                    colSpan: 4,
                    label:
                        <TableBody>
                            <TableCell style={{ width: "120px", textAlign: "center", border: "none" }} colSpan={2}>
                                {Number(asPlanCount)}
                            </TableCell>
                            <TableCell style={{ width: "120px", textAlign: "center", border: "none" }} colSpan={2}>
                                {Number(delayCount)}
                            </TableCell>
                        </TableBody>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };
    const handleGetFiscalYear = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    setFiscalYear(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    const handleGetReport = useCallback(async () => {
        let condition: any = {
            // idFiscalYear: idFiscalYear
        }
        if (+idFiscalYear) condition = { ...condition, idFiscalYear: +idFiscalYear }
        if (filterData.idClusters) condition = { ...condition, idClusters: filterData.idClusters?.idClusters }
        if (filterData.idEmployee) condition = { ...condition, idEmployee: filterData.idEmployee?.idEmployee }
        if (filterData.idTactics) condition = { ...condition, idTactics: filterData.idTactics?.idTactics }
        if (filterData.idDepartment) condition = { ...condition, idDepartment: filterData.idDepartment?.idDepartment }
        if (filterData.idPlan) condition = { ...condition, idPlan: filterData.idPlan?.idPlan }
        if (filterData.idType) condition = { ...condition, idType: filterData.idType?.idType }
        if (filterData.idStrategy) condition = { ...condition, idStrategy: filterData.idStrategy?.idStrategy }
        await ReportApi.getTrackOverview(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result)
                    setDataReport(res.data?.result)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [
        idFiscalYear,
        filterData.idClusters,
        filterData.idEmployee,
        filterData.idTactics,
        filterData.idDepartment,
        filterData.idPlan,
        filterData.idType,
        filterData.idStrategy
    ])
    const handleGetFile = async (format: 'pdf' | 'excel') => {
        try {
            dispatch(setLoading())
            let condition: any = {
                format: format
            }
            if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
            if (filterData.idDepartment) condition = { ...condition, idDepartment: filterData.idDepartment?.idDepartment }
            if (filterData.idClusters) condition = { ...condition, idClusters: filterData.idClusters?.idClusters }
            if (filterData.idEmployee) condition = { ...condition, idEmployee: filterData.idEmployee?.idEmployee }
            if (filterData.idTactics) condition = { ...condition, idTactics: filterData.idTactics?.idTactics }
            if (filterData.idPlan) condition = { ...condition, idPlan: filterData.idPlan?.idPlan }
            if (filterData.idType) condition = { ...condition, idType: filterData.idType?.idType }
            if (filterData.idStrategy) condition = { ...condition, idStrategy: filterData.idStrategy?.idStrategy }
            await ReportApi.getFileTrackOverview(condition)
                .then(res => {
                    if (res.status === 200) {
                        dispatch(unsetLoading())
                        const data = res?.data
                        if (format === 'pdf') {
                            const blob = new Blob([data], { type: 'application/pdf' });
                            saveAs(blob, 'report-pdf-e-monitering');
                        } else if (format === 'excel') {
                            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            saveAs(blob, 'report-xlsx-e-monitering');
                        }
                    }
                })
                .catch(error => {
                    dispatch(unsetLoading())
                    console.log(error)
                })
        } catch (error) {
            console.log(error)
        }
    }


    const handleGetStrategy = useCallback(async () => {
        let condition: any = {
            page: 1,
            limit: 10,
        }
        if (keyword_id_strategy) condition = { ...condition, keyword: keyword_id_strategy }
        await StrategyApi.getStrategy(condition)
            .then(res => {
                if (res.status === 200) {
                    setStrategy(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [keyword_id_strategy])
    const handleGetTactics = useCallback(async (idStrategy: number) => {
        let condition: any = {
            page: 1,
            limit: 10,
            idStrategy: idStrategy
        }
        if (keyword_id_tactics) condition = { ...condition, keyword: keyword_id_tactics }
        await TacticsApi.getTactics(condition)
            .then(res => {
                if (res.status === 200) {
                    set_tactics(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [keyword_id_tactics, filterData.idStrategy])
    const handleGetPlan = useCallback(async () => {
        let condition: any = {
            page: 1,
            limit: 10,
        }
        if (keyword_id_plan) condition = { ...condition, keyword: keyword_id_plan }
        await PlanApi.getPlans(condition)
            .then(res => {
                if (res.status === 200) {
                    setPlan(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [keyword_id_plan])
    const handleGetDepartment = useCallback(async () => {
        let condition: any = {
            page: 1,
            limit: 10,
        }
        if (keyword_id_department) condition = { ...condition, keyword: keyword_id_department }
        await DepartMentApi.getDepartments(condition)
            .then(res => {
                if (res.status === 200) {
                    setDepartment(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [keyword_id_department])
    const handleGetClusters = useCallback(async () => {
        let condition: any = {
            page: 1,
            limit: 10,
        }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (keyword_id_cluster) condition = { ...condition, keyword: keyword_id_cluster }
        await ClustersApi.getClusters(condition)
            .then(res => {
                if (res.status === 200) {
                    setClusters(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [keyword_id_cluster, idFiscalYear])
    const handleGetEmployees = useCallback(async () => {
        let condition: any = {
            page: 1,
            limit: 10
        }
        if (keyword_id_employee) condition = { ...condition, keyword: keyword_id_employee }
        if (filterData.idDepartment) condition = { ...condition, idDepartment: filterData.idDepartment?.idDepartment }
        await EmployeesApi.getEmployees(condition)
            .then(res => {
                if (res.status === 200) {
                    setEmployees(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [filterData.idDepartment, keyword_id_employee])
    const handleGetType = useCallback(async () => {
        let condition: any = {
            page: 1,
            limit: 10
        }
        if (keyword_id_types) condition = { ...condition, keyword: keyword_id_types }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        await TypesApi.getType(condition)
            .then(res => {
                if (res.status === 200) {
                    setTypes(res.data?.result?.items);
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [idFiscalYear, keyword_id_types])


    useEffect(() => {
        handleGetReport();
    }, [handleGetReport])

    useEffect(() => {
        handleGetFiscalYear();
    }, [])

    useEffect(() => {
        handleGetEmployees();
    }, [handleGetEmployees])
    useEffect(() => {
        handleGetType();
    }, [handleGetType])
    useEffect(() => {
        handleGetClusters();
    }, [handleGetClusters])
    useEffect(() => {
        handleGetStrategy();
    }, [handleGetStrategy])
    useEffect(() => {
        handleGetDepartment();
    }, [handleGetDepartment])
    useEffect(() => {
        handleGetPlan();
    }, [handleGetPlan])

    useEffect(() => {
        if (filterData.idStrategy) {
            handleGetTactics(filterData.idStrategy?.idStrategy)
        }
    }, [handleGetTactics])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <motion.div
                        initial={{ x: 100 }}
                        animate={{ x: 0 }}
                        transition={{ ease: "backInOut", stiffness: 100 }}
                        className='w-full h-auto'>
                        <section>
                            <Typography className='text-primary' variant='h4'>
                                {"รายงาน"}
                            </Typography>
                            <Typography variant='h6' className='text-primary mt-3'>
                                {"รายงานสรุปผลการติดตามและประเมินผลแผนพัฒนาท้องถิ่นในภาพรวม"}
                            </Typography>
                        </section>
                        <section className='w-full mt-8'>
                            <article className='flex flex-col md:flex-row justify-between items-center'>
                                <span className='w-full md:max-w-xs'>
                                    {/* <FilterSelect
                                        headingNormal
                                        heading={t("ปีงบประมาณ")}
                                        renderValue={() => idFiscalYear === 0 ? "ทั้งหมด" : fiscalYear?.find((list: any) => list?.idFiscalYear === idFiscalYear)?.fiscalYear}
                                        label={t('STATUS.LABEL')}
                                        selectId="select-fiscal-year"
                                        value={idFiscalYear}
                                        labelId="label-fiscal-year"
                                        onchange={(event) => {
                                            const value = event.target.value
                                            value && setIdFiscalYear(Number(value))
                                        }}
                                        options={[
                                            <MenuItem onClick={() => setIdFiscalYear(0)} value={0}>{"ทั้งหมด"}</MenuItem>,
                                            fiscalYear && fiscalYear?.map((list: any) => (
                                                <MenuItem disabled={list?.fiscalYearStatus === t("STATUS.INACTIVE")} key={list?.idFiscalYear} value={list?.idFiscalYear}>
                                                    {list?.fiscalYear}
                                                </MenuItem>
                                            ))]}
                                    /> */}
                                </span>
                                <span className='w-full md:w-auto'>
                                    <div className='w-auto flex flex-col self-end gap-2'>
                                        <MenuDropdown
                                            headingNormal
                                            heading='ส่งออกเอกสาร'
                                            buttonName='ดาวน์โหลด'
                                            menuItems={[
                                                { id: 1, name: "pdf", onClick: () => handleGetFile('pdf') },
                                                { id: 2, name: 'excel', onClick: () => handleGetFile('excel') }
                                            ]}
                                        />
                                    </div>
                                </span>

                            </article>
                        </section>
                        <StateComponents
                            sxContainer={{ mt: 2 }}
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        isFilter: true,
                                        heading: "ปีงบประมาณ",
                                        getOptionLabel: (op) => op?.fiscalYear || "",
                                        labelId: "idPlan",
                                        placeholder: "ทั้งหมด",
                                        onChange: (_: any, val: any) => {
                                            if (val) {
                                                setIdFiscalYear(val?.idFiscalYear)
                                            } else {
                                                setIdFiscalYear(0)
                                            }
                                        },
                                        options: fiscalYear || [],
                                        value: fiscalYear?.find((x) => x?.idFiscalYear === idFiscalYear) || null,
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        isFilter: true,
                                        heading: "แผนงาน",
                                        getOptionLabel: (op) => op?.planName || "",
                                        labelId: "idPlan",
                                        onInputChange: (_: any, val: string) => {
                                            debouncedApiCall({ searchItem: val, setItem: set_keyword_id_plan })
                                        },
                                        placeholder: "ทั้งหมด",
                                        onChange: (_: any, val: any) => {
                                            handleChangeFilterData('idPlan', val);
                                        },
                                        options: plan || [],
                                        value: filterData.idPlan,
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        isFilter: true,
                                        heading: "ยุทธศาสตร์",
                                        getOptionLabel: (op) => op?.strategyName || "",
                                        labelId: "idStrategy",
                                        onInputChange: (_: any, val: string) => {
                                            debouncedApiCall({ searchItem: val, setItem: set_keyword_id_strategy })
                                        },
                                        placeholder: "ทั้งหมด",
                                        onChange: (_: any, val: any) => {
                                            handleChangeFilterData('idStrategy', val);
                                            handleChangeFilterData('idTactics', null);
                                        },
                                        options: strategy || [],
                                        value: filterData.idStrategy,
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        isFilter: true,
                                        heading: "กลยุทธ์",
                                        disabled: !filterData.idStrategy,
                                        getOptionLabel: (op) => op?.tacticsName || "",
                                        labelId: "idTactics",
                                        onInputChange: (_: any, val: string) => {
                                            debouncedApiCall({ searchItem: val, setItem: set_keyword_id_tactics })
                                        },
                                        placeholder: "ทั้งหมด",
                                        onChange: (_: any, val: any) => handleChangeFilterData('idTactics', val),
                                        options: tactics || [],
                                        value: filterData.idTactics,
                                    }
                                },
                                {
                                    seq: 5,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        isFilter: true,
                                        heading: "หน่วยงาน",
                                        getOptionLabel: (op) => op?.departmentName || "",
                                        labelId: "idDepartment",
                                        onInputChange: (_: any, val: string) => {
                                            debouncedApiCall({ searchItem: val, setItem: set_keyword_id_department })
                                        },
                                        placeholder: "ทั้งหมด",
                                        onChange: (_: any, val: any) => handleChangeFilterData('idDepartment', val),
                                        options: department || [],
                                        value: filterData.idDepartment,
                                    }
                                },
                                {
                                    seq: 6,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        isFilter: true,
                                        heading: "ประเภทกลุ่มภารกิจ",
                                        getOptionLabel: (op) => op?.clustersName || "",
                                        labelId: "idClusters",
                                        onInputChange: (_: any, val: string) => {
                                            debouncedApiCall({ searchItem: val, setItem: set_keyword_id_cluster })
                                        },
                                        placeholder: "ทั้งหมด",
                                        onChange: (_: any, val: any) => handleChangeFilterData('idClusters', val),
                                        options: clusters || [],
                                        value: filterData.idClusters,
                                    }
                                },
                                {
                                    seq: 7,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        isFilter: true,
                                        heading: "ประเภทโครงการ",
                                        getOptionLabel: (op) => op?.typeName || "",
                                        labelId: "idType",
                                        onInputChange: (_: any, val: string) => {
                                            debouncedApiCall({ searchItem: val, setItem: set_keyword_id_types })
                                        },
                                        placeholder: "ทั้งหมด",
                                        onChange: (_: any, val: any) => handleChangeFilterData('idType', val),
                                        options: types || [],
                                        value: filterData.idType,
                                    }
                                },
                                {
                                    seq: 8,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        isFilter: true,
                                        heading: "ผู้รับผิดชอบโครงการ",
                                        getOptionLabel: (op) => `${op?.employeeFirstname || ""} ${op?.employeeLastname}`,
                                        labelId: "idEmployee",
                                        onInputChange: (_: any, val: string) => {
                                            debouncedApiCall({ searchItem: val, setItem: set_keyword_id_employee })
                                        },
                                        placeholder: "ทั้งหมด",
                                        onChange: (_: any, val: any) => handleChangeFilterData('idEmployee', val),
                                        options: employees || [],
                                        value: filterData.idEmployee,
                                    }
                                },
                            ]}
                        />
                        <section className='w-full mt-3'>
                            <TableCustom
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalPage}
                                rowsData={dataReport && dataReport?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                                hidePagination
                                tableFixedWidth
                            />
                        </section>
                    </motion.div>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default ReportSummary
